var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeChargingSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5351562,11.1210938L18.4140625,1C17.125-0.2890625,14.875-0.2890625,13.5859375,1L3.4648438,11.1210938 C2.5205078,12.0654297,2,13.3212891,2,14.6572266V30c0,1.1025391,0.8974609,2,2,2h24c1.1025391,0,2-0.8974609,2-2V14.6572266 C30,13.3212891,29.4794922,12.0654297,28.5351562,11.1210938z M17,30v-4h4c1.1025391,0,2-0.8974609,2-2v-8 c0-1.1025391-0.8974609-2-2-2h-1V8h-2v6h-4V8h-2v6h-1c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h4v4H4V14.6572266 c0-0.8017578,0.3125-1.5556641,0.8789062-2.1220703L15,2.4140625C15.2675781,2.1474609,15.6220703,2,16,2 s0.7324219,0.1474609,1,0.4140625l10.1210938,10.1210938C27.6875,13.1015625,28,13.8554688,28,14.6572266L28.0019531,30H17z M21,16 l0.0019531,8H11v-8H21z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChargingSmall);
export default __webpack_public_path__ + "static/media/home-charging--small.2a26dd7ec750c004e6ffc5d8c461f352.svg";
export { ForwardRef as ReactComponent };